// extracted by mini-css-extract-plugin
module.exports = {"container":"tabbed-section_container__4xQi7","content":"tabbed-section_content__HWPtQ"};